//import { useCallback, useState } from "react";

export const parseFromBin = (str, radix) => {
	switch (radix)
	{
	case 8:
		return parseInt(str, 2).toString(8);
	case 10:
		return String(parseInt(str, 2));
	case 16:
		return parseInt(str, 2).toString(16);
	}
	return "parseFromBin"
}

export const parseFromOct = (str, radix) => {
	switch (radix)
	{
	case 2:
		return parseInt(str, 8).toString(2);
	case 10:
		return String(parseInt(str, 8));
	case 16:
		return parseInt(str, 8).toString(16);
		break;
	}
	return "parseFromOct"
}

export const parseFromDeci = (str, radix) => {
	switch (radix)
	{
	case 2:
		return Number(str).toString(2);
	case 8:
		return Number(str).toString(8);
	case 16:
		return Number(str).toString(16);
	}
	return "parseFromDeci"
}

export const parseFromHex = (str, radix) => {
	switch (radix)
	{
	case 2:
		return parseInt(str, 16).toString(2);
	case 8:
		return parseInt(str, 16).toString(8);
	case 10:
		return String(parseInt(str, 16));
	}
	return "perseBin"
}
